const page404 = () => {
  
  var gifWrap = $('.gif-wrap'),
      random = Math.floor(Math.random() * 50) + 1;

  var xhr = $.get("https://api.giphy.com/v1/gifs/search?api_key=c3rXTNH5v83GEmP2iPDDKDvcoBXXIV9h&q=funny-animals&limit=4&offset="+random+"&rating=G&lang=en");

  xhr.done(function(data) {

    $.each(data.data, function(i, item) {
      var gifUrl = item['images']['original']['webp'];
      gifWrap.append('<div class="gif gif'+i+'" style="background-image:url('+gifUrl+')"></div>');
    });

  });
  
}

export {
  page404
}